export default "__VITE_ASSET__XWRjRAIb__"